import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function DatePreview({
  value
}) {
  return _jsx(WidgetPreviewContainer, {
    children: value ? value.toString() : null
  });
}
DatePreview.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};
export default DatePreview;